<template>
	<section>
		
		<pagination-component
			v-if="pages > 1"
			:totalPages="pages"
			:perPage="20"
			:currentPage="currentPage"
			@pageChanged="getNewQuestions"
		/>
		<filter-wrapper @updateFilter="updateFilter" :showFilter="false" />

		<table style="width: 100%;">
			<tr>
				<th></th>
				<th>Titre</th>
				<th>Auteur</th>
				<th>Séquence</th>
				<th>Niveau</th>
				<th>Voir</th>
				<th>Modifier</th>
				<th>Supprimer</th>
				<th>Status</th>
			</tr>
			<tr v-for="(question, index) in questions" :key="index">
				<td>{{ index + 1 }}</td>
				<td v-html="question.question"></td>
				<td>{{ question.teacher_name }}</td>
				<td
					v-if="
						this.$store.state.sequences.length !== 0 &&
						this.$store.state.chapters.length !== 0
					"
				>
					{{ question.sequence_name }}
				</td>
				<td v-if="this.$store.state.levels.length !== 0">
					{{ question.level_name }}
				</td>
				<td>
					<button class="see" @click="showPopUpPreview(question)">
						<img src="/img/super-admin/blue-eye.svg" alt="" />
					</button>
				</td>
				<td>
					<router-link
						class="table-btn"
						v-if="checkIfSuperAdminAndValidatedStatus(question.status)"
						:to="{
							name: 'MyResourcesEditQcm',
							params: { id: question.id },
						}"
						>Modifier</router-link
					>
				</td>
				<td>
					<button
						class="delete"
						v-if="checkIfSuperAdminAndValidatedStatus(question.status)"
						@click="deleteQuestion(question.id)"
					>
						<img src="/img/super-admin/blue-trash.svg" alt="" />
					</button>
				</td>
				<td> <span :style="getStyleColor(question.status)">{{  translate(question.status)  }}</span></td>
				
			</tr>
			
		</table>
		<Teleport to="body">
			<pop-up-preview-qcm-question
				v-if="isPopUpPreviewVisible"
				@close="isPopUpPreviewVisible = false"
				@updateQuestion="removeQuestion"
				:question="selectedQuestion"
			/>
		</Teleport>
	</section>
</template>
<script>
import PaginationComponent from '../../../../Utils/PaginationComponent.vue'
import PopUpPreviewQcmQuestion from '../../../../PopUp/QCM/PopUpPreviewQcmQuestion.vue'
import { deleteQCMQuestionService, filteredQCMQuestionsService } from '../../../../../services/qcmQuestionsServices'
import FilterWrapper from '../../../Search/FilterWrapper.vue'

export default {
	components: {
		PaginationComponent,
		PopUpPreviewQcmQuestion,
		FilterWrapper
	},
	props: {
		status: {
			type: String,
			default: 'VALIDATED',
		}
	},
	data() {
		return {
			questions: [],
			currentPage: 0,
			pages: 0,
			filter: {
				level: '',
				teacher: '',
				chapter: '',
				status: '',
				subject: '',
			},
			isPopUpPreviewVisible: false,
			selectedQuestion: null,
		}
	},
	methods: {
		removeQuestion(id) {
			this.questions = this.questions.filter((question) => question.id !== id)
		},
		showPopUpPreview(question){
			this.isPopUpPreviewVisible = true
			this.selectedQuestion = question
		},
		translate(status) {
			switch (status) {
				case 'VALIDATED':
					return 'Approuvé'
				case 'REFUSED':
					return 'Refusé'
				case 'PENDING':
					return 'En attente'
			}
		},
		getStyleColor(status) {
			switch (status) {
				case 'VALIDATED':
					return `color: #17A81C`
				case 'PENDING':
					return `color: #fff;background-color:#F0961A;`
				case 'REFUSED':
					return `color: #DE1D1D`
				case 'PRIVATE':
					return `color: #000`
			}
		},
		async allQcmQuestions() {
			const filter = `?teacher=${this.$store.state.user.user}`
			const res  = await filteredQCMQuestionsService(filter)
			this.questions = res.results
			const total = res.count
			this.pages = Math.ceil(total / 20)

		},
		checkIfSuperAdminAndValidatedStatus(status) {

			if (status == 'VALIDATED') {
				if (this.$store.state.user.role == 'SUPER_ADMIN')
					return true
				return false
			}
			return true
		},
		async deleteQuestion(id) {
			if (confirm("Êtes-vous sûr de vouloir supprimer ?")) {
				await deleteQCMQuestionService(id)
				this.getNewQuestions()
			}
		},
		updateFilter(data) {
			this.filter.level = data.level
			this.filter.chapter = data.chapter
			this.filter.subject = data.subject
			this.filter.search = data.search
			this.changeFilter()
		},
		async changeFilter(e){
			this.currentPage = e || 0
			const level = this.filter.level ? `&level=${this.filter.level}` : ''
			const chapter = this.filter.chapter ? `&chapter=${this.filter.chapter}` : ''
			const subject = this.filter.subject ? `&subject=${this.filter.subject}` : ''
			const search = this.filter.search ? `&search=${this.filter.search}` : ''
			const filter = `?teacher=${this.$store.state.user.user}${chapter}${level}${subject}${search}&offset=${this.currentPage * 20}`
			
			const res = await filteredQCMQuestionsService(filter)
			this.questions = res.results
			const total = res.count
			this.pages = Math.ceil(total / 20)
		}
	},
	created() {
		this.allQcmQuestions()
	},
}
</script>
